import {Input} from 'antd'

import {Button, Form, FormItem, Select} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES, EMAIL_FIELD_RULES} from 'common/constants'
import {
  usePassRequestMilestone,
  useAddAMLBeneficiary,
  useUpdateAMLBeneficiary,
  isMilestonePassed,
} from '..'

interface AMLBeneficiaryFormProps {
  item?: any
  request?: any
  onClose: () => void
}
export default function AMLBeneficiaryForm({
  item,
  request,
  onClose,
}: AMLBeneficiaryFormProps) {
  const {
    mutate: passRequestMilestone,
    isMutating: isPassRequestMilestoneMutating,
  } = usePassRequestMilestone(request?.uuid, 'aml-check-initiated', onClose)
  const {uuid: projectUuid} = request.project
  const {mutate: addAMLBeneficiary, isMutating: isAddAMLBeneficiaryMutating} =
    useAddAMLBeneficiary(
      projectUuid,
      request && isMilestonePassed('aml-check-initiated', request)
        ? onClose
        : passRequestMilestone
    )
  const {
    mutate: updateAMLBeneficiary,
    isMutating: isUpdateAMLBeneficiaryMutating,
  } = useUpdateAMLBeneficiary(item?.uuid, projectUuid, onClose)
  const inputRef = useInputFocus()

  const isEdit = Boolean(item)

  const handleFinish = (values: any) => {
    if (isEdit) return updateAMLBeneficiary(values)
    addAMLBeneficiary(values)
  }

  const initialValues = isEdit
    ? {
        name: item.name,
        phone: item.phone.slice(3),
        email: item.email,
        type: item.type,
      }
    : {
        type: 'manual',
      }

  if (process.env.NODE_ENV === 'development') {
    initialValues.name  = initialValues.name  || 'lotus';
    initialValues.phone = initialValues.phone || '18668177';
    initialValues.email = initialValues.email || 'lotus@vincentcapital.cn';
  }

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <FormItem name="name" label="Name" rules={FIELD_RULES}>
        <Input ref={inputRef} />
      </FormItem>
      <FormItem name="phone" label="Phone number" rules={FIELD_RULES}>
        <Input addonBefore="+64" />
      </FormItem>
      <FormItem name="email" label="Email" rules={EMAIL_FIELD_RULES}>
        <Input />
      </FormItem>
      <FormItem name="type" label="AML check" rules={FIELD_RULES}>
        <Select options={typeOptions} />
      </FormItem>
      <Button
        block
        htmlType="submit"
        loading={
          isAddAMLBeneficiaryMutating ||
          isPassRequestMilestoneMutating ||
          isUpdateAMLBeneficiaryMutating
        }
      >
        {request.status === 'approved' ? 'Save' : 'Send sms with link to form'}
      </Button>
    </Form>
  )
}

const typeOptions = [
  {value: 'manual', label: 'Manual'},
  // {value: 'green-id', label: 'Green ID'},
]
